<template>
  <div class="announcement">
    <div class="section hero-grey">
      <div class="container">
        <div class="center">
          <h2 class="h2 margin">
            CONVOCATORIAS PÚBLICAS EN LAS ESCUELAS SUPERIORES DE
            FORMACIÓN DE MAESTRAS Y MAESTROS
          </h2>
        </div>
      </div>
    </div>

    <div class="section padding-bottomss">
      <div
        class="container"
        v-for="(item, index) in convocatorias_esfm"
        :key="index"
      >
        <h3 class="h2 margin">{{ item.esfm }}</h3>

        <div data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
          <div class="tabs-content w-tab-content">
            <div class="w-tab-pane">
              <div class="main-container">

                <div
                  class="card-container"
                  v-if="item.convocatorias.length > 0"
                >
                  <div
                    class="card"
                    style="display: block;"
                    v-for="(convocatoria, i) in item.convocatorias"
                    :key="i"
                    :class="i == 0 ? 'card_bg' : ''"
                  >
                    <small class="textss">
                      Fecha:
                      {{ convocatoria.created_at | formatdate }}
                    </small>

                    <h5 class="card__titles">
                      {{ convocatoria.cite }}
                      <br />
                    </h5>

                    <p class="card_description margins">
                      {{ convocatoria.descripcion }}
                    </p>

                    <p class="card__applys">
                      <a
                        :href="`${serve}/convocatorias/${convocatoria.documento}`"
                        class="btn-download text-small"
                        target="_blank"
                        download
                      >
                        Descargar
                        <i class="fas fa-arrow-right"></i>
                      </a>
                    </p>
                  </div>
                </div>

                <div class="card-container" v-else>
                  <div class="alert">
                    <span class="text-red">
                      No existen convocatorias publicadas
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="center">
        <p>Cargando convocatorias...</p>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "../router/endpoint";
import axios from "axios";

export default {
  name: "convocatory",

  data() {
    return {
      loading: false,
      convocatorias_esfm: [],
      serve: "",
    };
  },

  mounted() {
    this.serve = Service.getServe();
    this.getConvocatorias();
  },

  methods: {
    getConvocatorias() {
      this.loading = true;

      axios
        .get(
          Service.getBase() + "lista/convocatorias",
          Service.getHeader()
        )
        .then((response) => {
          this.convocatorias_esfm = response.data;
        })
        .catch((error) => {
          console.error("Error al cargar convocatorias", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped></style>